import { useCallback, useEffect, useRef, useState } from 'react';

export const useCopy = (holdMs = 1200) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = useCallback(
    async (value: string) => {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), holdMs);
    },
    [holdMs],
  );

  return { copied, copy };
};
